import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Logger from 'utils/logger';

import { MenuItem } from './actionMenu';
import { KEYS, LABELS } from './keys';

interface CopyMenuItemProps {
  children: JSX.Element | string;
  value: string;
}

export const CopyMenuItem = ({ children, value }: CopyMenuItemProps) => {
  const { t } = useTranslation();
  const [isCopied, setCopied] = useState<boolean>(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), KEYS.COPY_MESSAGE_TIMEOUT);
    } catch (err) {
      Logger.error('Failed to copy value: ', err);
    }
  };

  const content = isCopied ? t(LABELS.COPY_MESSAGE) : children;

  return (
    <MenuItem disabled={isCopied} onClick={copy}>
      {content}
    </MenuItem>
  );
};
